(function () {

    'use strict';

    angular.module('FotocApp')

    .filter('layoutsType', function () {

        return function (items, $type) {

           
            var combined = {};
            var simples = {};
            for(var i in items){
                //if(items[i].)
               if(items[i].simple){
                simples[i] = items[i];
               }else{
                combined[i] = items[i];
               }
            }
     
            return $type=='simple'? simples : combined;

        }
    })

    .component('layouts', {
 
        templateUrl: (USE_TEMPLATE_CACHE ? '' :  window.BASE_PATH  + '../../src/') + 'editor/tools/layouts.component.html',
        bindings: {},
        controller: ['$scope', '$editorService','$canvasService', '$lang', function ($scope, $editorService, $canvasService, $lang) {

            var self = this;
        
            this.$canvasService = $canvasService;
            this.$editorService = $editorService;
            
            $scope.$lang = $lang;

            this.type_selected = 'combined';
            this.tab_x = 0;

             this.setType = function($type){
                
                this.type_selected = $type;
                switch($type){
                    case 'combined': 
                        this.tab_x = 0;
                        $editorService.data.group = 1;
                    break;
                    case 'mosaic':
                        this.tab_x = $editorService.ui.layoutMosaicTabX;
                        $editorService.data.group = 0;
                    break;
                    case 'simple': 
                        this.tab_x = 33.333*2;
                        $editorService.data.group = 1;
                    break;
                }
                $canvasService.changeTypeGroup()
                $editorService.setLayout($editorService.data.layout_id)

             }


             this.setLayout = function ($layout_key){
                $editorService.ui.view = {type:'edit'};
                $editorService.setLayout($layout_key)
             }
            

        }]
        
        
    })

})();